import PropTypes from 'prop-types';
import { useNotify } from 'react-admin';
import { CustomButton } from '@/components/global/buttons/CustomButton';
import CopyIcon from '@/assets/icons/copy-icon.svg?react';
import { copyTextToClipboard, formatDeviceConfigForClipboard } from '@/helpers/device/deviceConfig.js';

export const DeviceConfigCopyButton = ({ parameters, rawConfig, disabled = false }) => {
    const notify = useNotify();

    const handleCopy = async () => {
        const payload = formatDeviceConfigForClipboard(parameters, rawConfig);

        if (!payload) {
            notify('resources.device.notifications.configurationCopyError', { type: 'error' });
            return;
        }

        const copied = await copyTextToClipboard(payload);
        if (copied) {
            notify('resources.device.notifications.configurationCopied', { type: 'success' });
            return;
        }

        notify('resources.device.notifications.configurationCopyError', { type: 'error' });
    };

    return (
        <CustomButton color='secondary' label='resources.device.labels.copyConfiguration' startIcon={<CopyIcon />} onClick={handleCopy} disabled={disabled} />
    );
};

DeviceConfigCopyButton.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.object),
    rawConfig: PropTypes.string,
    disabled: PropTypes.bool,
};
